module.exports = __webpack_public_path__ + "static/elkabetz-hex-gray-5b417687210fb96a3ddb61929c789d37.png";